<template>
    <card class="card-default m-0">
        <card-header>
            {{ location.name }}
            <span class="id align-self-center">
                (id:{{ location.id }})
            </span>
        </card-header>
        <card-body class="pt-0" v-if="location.type == 'provider'">
            <span v-for="l of location.locations" class="badge badge-pill badge-primary location-pill">{{ l.name }}</span>
        </card-body>
        <card-body class="py-0">
            <gmap-map
                :center="position"
                :zoom="location.zoom"
                class="map">
                <gmap-marker
                    :position="position"
                />
            </gmap-map>
        </card-body>
        <card-body>
            <p>{{ location.address }}</p>
            <div class="text-center" v-if="!spark.state.user.is_location_user">
                <a href="#" @click.prevent="$emit('click:manage', location)"
                    class="card-link">
                    MANAGE
                </a>
                <a href="#" @click.prevent="openReviewWidgetModal(location)"
                    class="card-link">
                    WIDGET
                </a>
                <a href="#" @click.prevent="$emit('click:delete', location)"
                    class="card-link text-danger">
                    DELETE
                </a>
            </div>
            <div class="text-center" v-else>
                <a href="#" @click.prevent="openModal(location)" class="card-link">
                    DETAILS
                </a>
                <a href="#" @click.prevent="openReviewWidgetModal(location)" class="card-link">
                    WIDGET
                </a>
            </div>
        </card-body>
    </card>
</template>

<script>
    export default {
        props: {
            location: { required: true },
        },

        computed: {
            position() {
                return {
                    lat: this.location.latitude,
                    lng: this.location.longitude
                };
            },
        },

        methods: {
            // showReviews(location) {
            //     // temporary
            //     window.location = laroute.route('location.reviews', {location: location.id});
            // },
            openModal(location) {
                this.$emit('openDetailsModal', location);
            },

            openReviewWidgetModal(location) {
                this.$emit('openReviewWidgetModal', location)
            }
        }
    }
</script>

<style lang="scss">
    .map {
        width: 100%;
        height: 150px;
    }

    .id {
        font-size: 0.8em;
        padding-left: 5px;
        color: #B2B2B2;
    }

    .location-pill {
        margin-right: 5px;
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
